import { render, staticRenderFns } from "./star-icon.vue?vue&type=template&id=c9037dda&"
import script from "./star-icon.vue?vue&type=script&lang=js&"
export * from "./star-icon.vue?vue&type=script&lang=js&"
import style0 from "./star-icon.vue?vue&type=style&index=0&id=c9037dda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports